import {getAdminLanguage} from "./language"

export const ADMIN_TIME_ZONE = "Asia/Tashkent"

export const getAdminRequestHeaders = () => ({
    "Accept-Language": getAdminLanguage(),
    "X-Time-Zone": ADMIN_TIME_ZONE
})

export const applyAdminRequestHeaders = (headers: Headers) => {
    headers.set("Accept-Language", getAdminLanguage())
    if (!headers.has("X-Time-Zone")) {
        headers.set("X-Time-Zone", ADMIN_TIME_ZONE)
    }

    return headers
}
